import crudAction from './actions'

export default {
  name: 'brokerKitData',
  namespace: 'broker_kit_data',
  methods: [
    ...crudAction,
  ]
}
